"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = exports.FormAction = exports.FormTitle = exports.FormText = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var FormItem_1 = require("./FormItem");
var FormControl_1 = require("./FormControl");
var create_rocket_1 = require("../_util/create-rocket");
var FormContext_1 = require("./FormContext");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.FormText = create_rocket_1.createRocket("Form.Text", "div.@{prefix}-form__text");
exports.FormTitle = create_rocket_1.createRocket("Form.Title", "h3.@{prefix}-form-title");
exports.FormAction = create_rocket_1.createRocket("Form.Action", "div.@{prefix}-form-operate");
exports.Form = forward_ref_with_statics_1.forwardRefWithStatics(function Form(_a, ref) {
    var _b;
    var layout = _a.layout, readonly = _a.readonly, hideLabel = _a.hideLabel, fixedLabelWidth = _a.fixedLabelWidth, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["layout", "readonly", "hideLabel", "fixedLabelWidth", "children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    // readonly 只和 fixed 共存
    var formClassName = classnames_1.default(classPrefix + "-form", (_b = {},
        _b[classPrefix + "-form--fixed-layout"] = layout === "fixed",
        _b[classPrefix + "-form--vertical"] = !readonly && (layout === "vertical" || layout === "inline-vertical"),
        _b[classPrefix + "-form--inline"] = !readonly && (layout === "inline" || layout === "inline-vertical"),
        _b[classPrefix + "-form--readonly"] = readonly,
        _b), className);
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: formClassName }, props),
        react_1.default.createElement(FormContext_1.FormContext.Provider, { value: {
                hideLabel: hideLabel,
                fixedLabelWidth: layout === "fixed" ? fixedLabelWidth : undefined,
            } }, children)));
}, {
    Item: FormItem_1.FormItem,
    Title: exports.FormTitle,
    Action: exports.FormAction,
    Control: FormControl_1.FormControl,
    Text: exports.FormText,
});
exports.Form.displayName = "Form";
//# sourceMappingURL=Form.js.map